import { render, staticRenderFns } from "./guideInfo.vue?vue&type=template&id=4a10888f&scoped=true"
import script from "./guideInfo.vue?vue&type=script&lang=js"
export * from "./guideInfo.vue?vue&type=script&lang=js"
import style0 from "./guideInfo.vue?vue&type=style&index=0&id=4a10888f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10888f",
  null
  
)

export default component.exports